export const NEEDS_REVIEW_REASONS = [
    { name: 'AB5', label: 'AB5' },
    { name: 'BadHolidayMultiplier', label: 'Bad Holiday Multiplier' },
    { name: 'CallbackDocumentationtRequired', label: 'Callback Doc Required' },
    { name: 'CallRateNotEntered', label: 'Call Rate Not Entered' },
    { name: 'EmptyRawTimesheet', label: 'Empty Raw Timesheet' },
    { name: 'FacilityTimesheetRequired', label: 'Facility Timesheet Required' },
    { name: 'HasComment', label: 'Timesheet Has Comment' },
    { name: 'HasRateExceptionNotes', label: 'Rate Exception Notes' },
    { name: 'HolidayExceptionNotes', label: 'Holiday Exception Notes' },
    { name: 'HolidayExpected', label: 'Holiday Expected' },
    { name: 'HolidayNotExpected', label: 'Holiday Not Expected' },
    { name: 'InvalidExpensePayor', label: 'Invalid Expense Payor' },
    { name: 'InvalidRateConfiguration', label: 'Invalid Rate Configuration' },
    { name: 'InvalidRequestData', label: 'Invalid Request Data' },
    { name: 'InvalidThreshold', label: 'Invalid Threshold' },
    { name: 'InvalidTrigger', label: 'Invalid Trigger' },
    { name: 'IsCorrection', label: 'Is Correction' },
    { name: 'MileageNotExpected', label: 'Mileage Not Expected' },
    { name: 'MissingClinicianData', label: 'Missing Clinician Data' },
    { name: 'MissingMailingAddress', label: 'Missing Mailing Address' },
    { name: 'MissingMileageRate', label: 'Missing Mileage Rate' },
    { name: 'MissingTimesheetImage', label: 'Missing Timesheet Image' },
    { name: 'Multiple24HourCallOnDay', label: 'Multiple 24 Hour Call On Day' },
    { name: 'NoActiveRateSet', label: 'No Active Rate Set' },
    { name: 'OnsiteConsultAdded', label: 'Onsite Consult Added' },
    { name: 'OverlappingEffectiveDates', label: 'Overlapping Effective Dates' },
    { name: 'OverlappingRateSets', label: 'Overlapping Rate Sets' },
    { name: 'OverThreshold', label: 'Over Bill / Pay Threshold' },
    { name: 'OvertimeDocumentationtRequired', label: 'Overtime Doc Required' },
    { name: 'PaperTimesheet', label: 'Paper Timesheet' },
    { name: 'RateNotFound', label: 'Rate Not Found' },
    { name: 'RegularHoursOn24HourCall', label: 'Regular Hours On 24 Hour Call' },
    { name: 'RequiresBookingConfirmation', label: 'Requires Booking Confirmation' },
    { name: 'RequiresManualProcessing', label: 'Requires Manual Processing' },
    { name: 'RequiresMileageVerification', label: 'Requires Mileage Verification' },
    { name: 'TimesheetNotExpected', label: 'Timesheet Not Expected' },
    { name: 'UnableToProcessTimesheet', label: 'Unable To Process Timesheet' },
    { name: 'UnapprovedWorkLocation', label: 'Unapproved Work Location' },
    { name: 'UnderGuaranteedThreshold', label: 'Under Guaranteed Threshold' },
    { name: 'UnderMargin', label: 'Low Bill / Pay Margin' },
    { name: 'UnderThreshold', label: 'Under Bill / Pay Threshold' },
    { name: 'UnknownInvEngIssueCode', label: 'Unknown Invoice Engine Issue Code' },
    { name: 'UnknownRateType', label: 'Unknown Rate Type' },
    { name: 'UnknownTriggerType', label: 'Unknown Trigger Type' },
    { name: 'UnknownUnitType', label: 'Unknown Unit Type' },
    { name: 'UnknownWorkLocation', label: 'Unknown Work Location' },
];

export const PROCESSED_TIMESHEET_STATUSES = {
    AutomaticallyProcessed: { description: 'AUTO PROCESSED', color: 'info' },
    NeedsReview: { description: 'NEEDS REVIEW', color: 'warning' },
    Resolved: { description: 'RESOLVED', color: 'success' },
    Cancelled: { description: 'CANCELLED', color: 'default' },
    Creating: { description: 'CREATING', color: 'default' },
    Errored: { description: 'ERRORED', color: 'error' },
    Posted: { description: 'POSTED', color: 'success' },
    Outdated: { description: 'OUTDATED', color: 'grey' },
    Invoiced: { description: 'INVOICED', color: 'success' },
    // Sub statuses
    TCReview: { description: 'TC REVIEW', color: 'warning' },
    TCHold: { description: 'TC HOLD', color: 'error' },
    BPReview: { description: 'BP REVIEW', color: 'warning' },
    BPQuestion: { description: 'BP QUESTION', color: 'error' },
};
// Returns a dictionary of status labels. This way you can get the label with PROCESSED_TIMESHEET_STATUS_LABELS["TCReview"]
export const PROCESSED_TIMESHEET_STATUS_LABELS = Object.keys(PROCESSED_TIMESHEET_STATUSES).reduce(
    (acc, status) => {
        acc[status] = PROCESSED_TIMESHEET_STATUSES[status].description;
        return acc;
    },
    {}
);
// Returns a dictionary of status colors. This way you can get the color with PROCESSED_TIMESHEET_STATUS_COLORS["TCReview"]
export const PROCESSED_TIMESHEET_STATUS_COLORS = Object.keys(PROCESSED_TIMESHEET_STATUSES).reduce(
    (acc, status) => {
        acc[status] = PROCESSED_TIMESHEET_STATUSES[status].color;
        return acc;
    },
    {}
);
